import React, { useMemo, useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoSection from 'eco-design/base/eco-section';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

interface Props {}

const Screen4: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.Screen4');
    const [active, setActive] = useState(0);
    const list = useMemo(
        () => [
            {
                tab: t('tab1'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1729602706652/pc_Charge.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1729602693059/m_Charge.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1729602693059/m_Charge.jpg',
                text1: t('value1'),
            },
            {
                tab: t('tab2'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1729602693244/pc_Recharge.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1729602693422/m_Recharge.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1729602693422/m_Recharge.jpg',
                text2: t('value2'),
                text3: t('value3'),
            },
        ],
        [t],
    );
    const curItem = useMemo(() => list.find((_i, idx) => idx === active), [active, list]);

    return (
        <div className={`${style.comp} temp-Screen4 Screen4 GtmModuleData-section`} id="Screen4" data-section-id="Screen4">
            <EcoImg pc={curItem?.pc} h5={curItem?.h5} pad={curItem?.pad} />
            <div className="info">
                <div className="tab">
                    {list.map((i, idx) => (
                        <div
                            className={`tab-item tab-${idx + 1} GtmModuleData-btn-text ${active === idx ? 'active' : ''}`}
                            key={i.tab}
                            onClick={() => {
                                setActive(idx);
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'tab_click',
                                    list_name: 'none',
                                    button_name: i.tab,
                                    __btn_id1: `${style.comp} tab-${idx + 1}`,
                                    __btn_id2: i.tab,
                                    __btn_type: 'text',
                                });
                            }}
                        >
                            {i.tab}
                        </div>
                    ))}
                </div>
                <EcoSection
                    title={t.rich('title', {
                        s: (v: string) => <span>{v}</span>,
                    })}
                    desc={t.rich('desc', {
                        t: (i: string) => (
                            <span className="sub-desc" style={{ fontSize: '0.7em' }}>
                                {i}
                            </span>
                        ),
                    })}
                />
            </div>
            {curItem?.text1 && <p className="text text1">{curItem.text1}</p>}
            {curItem?.text2 && <p className="text text2">{curItem.text2}</p>}
            {curItem?.text3 && <p className="text text3">{curItem.text3}</p>}
        </div>
    );
};
export default Screen4;
